import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { mapOrderTypeToWebApiPathComponent } from '@/store/orders/algoOrders/helper.ts';
import type { AlgoOrderType } from '@/store/orders/state.ts';

export const pauseAlgo = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, { orderRef: string; orderType: AlgoOrderType }>({
    query: ({ orderRef, orderType }) => ({
      url: `/oms/pause/${mapOrderTypeToWebApiPathComponent(orderType)}`,
      method: 'POST',
      body: { orderRef },
      headers: {
        // without this header, the response is a string
        // instead of JSON, even if the value is "application/json"
        //accept: '*/*',
      },
    }),
  });
};
